var map = {
	"./common/Footer/index.jsx": 6210,
	"./common/Header/index.jsx": 7025,
	"./common/Image/index.jsx": 7229,
	"./common/Layout/index.jsx": 3488,
	"./common/Link/index.jsx": 5475,
	"./common/SEO/index.jsx": 9088,
	"./common/ScrollToElement/index.jsx": 2450,
	"./common/Section/index.jsx": 5357,
	"./common/Slice/index.jsx": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7155;